import React, { useState, createContext } from "react";
import { createRoot } from "react-dom/client";

// Changing CSS injection order to be able to use our stylesheet without !important
import { StyledEngineProvider } from '@mui/material/styles';

import App from "./App";
import "./index.css";

// Global Context providers give us access to global state
// See React Context
import { QueryClientProvider, QueryClient } from "react-query";

const container = document.getElementById("root");
const root = createRoot(container);

const queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
<StyledEngineProvider injectFirst>
    <App />

</StyledEngineProvider>
  </QueryClientProvider>
);
